import BaseComponent from "../../../baseComponent.js";
import styles from "./styles.scss";

export default class StrokeWidth extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      stroke: this.props.strokeWidth !== undefined ? this.props.strokeWidth : 1
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      stroke: nextProps.strokeWidth !== undefined ? nextProps.strokeWidth : 1
    });
  }


  handleChange(event) {
    this.setState({
      stroke: event.target.value
    });
    this.props.onLegendChange('strokeWidth', event.target.value, true);
  }

  render() {
    return (
      <div className={styles.configLineWrapper}>
        <div className={styles.configLine}>
          <div className={styles.configLabel}>Weight</div>
          <div className={styles.configValue}>
            <input type="range"
                   min="1" max="15" step="1"
                   value={this.state.stroke}
                   onChange={this.handleChange}/>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/strokeWidth.jsx